import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { styleCollectionsAPI } from '../services/api';
import './Users.css';

const StyleCollections = () => {
  const navigate = useNavigate();
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCollections();
  }, []);

  const loadCollections = async () => {
    setLoading(true);
    try {
      const response = await styleCollectionsAPI.getAll();
      const list = response.data?.collections || [];
      setCollections(Array.isArray(list) ? list : []);
    } catch (error) {
      console.error('Error loading style collections:', error);
      toast.error('Error loading collections: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this style collection?')) return;
    try {
      await styleCollectionsAPI.delete(id);
      loadCollections();
      toast.success('Collection deleted');
    } catch (error) {
      toast.error('Error deleting: ' + (error.response?.data?.message || error.message));
    }
  };

  if (loading && collections.length === 0) {
    return <div className="loading">Loading style collections…</div>;
  }

  return (
    <div className="users-container">
      <div style={{ marginBottom: '20px' }}>
        <Link to="/style-collections/new" className="btn btn-primary" style={{ display: 'inline-block' }}>
          + New collection
        </Link>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Title</th>
              <th>Slug</th>
              <th>Type</th>
              <th>Products</th>
              <th>Active</th>
              <th>Featured</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!loading && collections.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                  No style collections yet
                </td>
              </tr>
            ) : (
              collections.map((c) => (
                <tr key={c.id}>
                  <td>{c.title || '—'}</td>
                  <td>
                    <code style={{ fontSize: 12 }}>{c.slug}</code>
                  </td>
                  <td>{c.type || '—'}</td>
                  <td>{c.products_count ?? 0}</td>
                  <td>{c.is_active ? 'Yes' : 'No'}</td>
                  <td>{c.is_featured ? 'Yes' : 'No'}</td>
                  <td className="actions">
                    <button type="button" className="btn btn-secondary" onClick={() => navigate(`/style-collections/${c.id}/edit`)}>
                      Edit
                    </button>
                    <button type="button" className="btn btn-danger" onClick={() => handleDelete(c.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StyleCollections;
